import { HighlightIcon, normalizeHomeHighlights } from "../lib/homeHighlights";

/** Cuatro columnas de valor (envío, garantía, etc.) en la página de inicio. */
export default function HomeHighlightsSection({ highlights }) {
    const items = normalizeHomeHighlights(highlights);

    if (items.length === 0) return null;

    return (
        <section
            className="max-w-7xl mx-auto px-4 py-16 grid gap-0 border border-[var(--lz-navy)] grid-cols-1 sm:grid-cols-2"
            style={{
                gridTemplateColumns:
                    items.length >= 3
                        ? `repeat(auto-fit, minmax(min(100%, 220px), 1fr))`
                        : undefined,
            }}
            data-testid="home-highlights"
        >
            {items.map((v, idx) => (
                <div
                    key={`${v.title}-${idx}`}
                    className="p-6 border-b sm:border-b border-[var(--lz-navy)]/20 last:border-b-0 sm:[&:not(:last-child)]:border-r"
                >
                    <div className="text-[var(--lz-orange)] mb-3">
                        <HighlightIcon name={v.icon} />
                    </div>
                    <div className="font-display text-xl font-bold uppercase">{v.title}</div>
                    <div className="text-sm text-[var(--lz-navy)]/70 mt-1">{v.description}</div>
                </div>
            ))}
        </section>
    );
}
